import { PLAN_PADDLE_IDS } from '../constants';

export const getTierAndBillingPeriod = (priceId: string) => {
  for (const [tier, periods] of Object.entries(PLAN_PADDLE_IDS)) {
    for (const [period, id] of Object.entries(periods)) {
      if (id.includes(priceId)) return { tier, billingPeriod: period };
    }
  }
  return null;
};
